var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app flex-row align-items-center",
      staticStyle: {
        background:
          "url('../../static/img/login-bg.jpg') no-repeat center center fixed",
        "-webkit-background-size": "cover",
        "-moz-background-size": "cover",
        "-o-background-size": "cover",
        "background-size": "cover"
      }
    },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c(
                "b-col",
                { attrs: { md: "8" } },
                [
                  _c(
                    "b-card-group",
                    {
                      staticClass: "login-modal-card-group",
                      attrs: { "no-border": "" }
                    },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "p-4 login-modal-card",
                          attrs: { "no-body": "" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.submit.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _c(
                            "b-card-body",
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "login-modal-title-wrapper marginT0 marginB-12"
                                },
                                [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "login-modal-title login-modal-title--bold"
                                    },
                                    [_vm._v("Reset Your Password")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "login-modal-text marginB-8" },
                                [
                                  _vm._v(
                                    "\n                Your password needs to meet the following requirements:\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("ul", { staticClass: "marginB-12" }, [
                                _c(
                                  "li",
                                  {
                                    class: {
                                      "login-modal-text": true,
                                      "login-modal-text--xs": true,
                                      passedColor: this.lengthPassed === true,
                                      failedColor: this.lengthPassed === false
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "\n                    MUST contain at least 8 characters\n                  "
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    class: {
                                      "login-modal-text": true,
                                      "login-modal-text--xs": true,
                                      passedColor: this.regexPassed === true,
                                      failedColor: this.regexPassed === false
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "\n                    MUST contain at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (!@#$%^&*?,._)\n                  "
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    class: {
                                      "login-modal-text": true,
                                      "login-modal-text--xs": true,
                                      passedColor:
                                        this.consecutiveRepeatPassed === true,
                                      failedColor:
                                        this.consecutiveRepeatPassed === false
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "\n                    MAY NOT contain repeating or consecutive characters\n                  "
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    class: {
                                      "login-modal-text": true,
                                      "login-modal-text--xs": true,
                                      passedColor:
                                        this.containEmailPassed === true,
                                      failedColor:
                                        this.containEmailPassed === false
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "\n                    MAY NOT contain part of your name or email\n                  "
                                      )
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-input-group",
                                { staticClass: "login-modal-form-input" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.password,
                                        expression: "password"
                                      }
                                    ],
                                    ref: "password",
                                    staticClass: "form-control",
                                    class: {
                                      "input-box": true,
                                      "is-danger": _vm.inputValidationErrors.has(
                                        "password"
                                      )
                                    },
                                    attrs: {
                                      type: "password",
                                      required: "",
                                      id: "password",
                                      name: "password",
                                      placeholder: "Password",
                                      "data-vv-delay": "500"
                                    },
                                    domProps: { value: _vm.password },
                                    on: {
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.resetPassword.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.password = $event.target.value
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.inputValidationErrors.has(
                                        "password"
                                      ),
                                      expression:
                                        "inputValidationErrors.has('password')"
                                    }
                                  ],
                                  staticClass: "alert-text help is-danger-msg"
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.inputValidationErrors.first(
                                          "password"
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-input-group",
                                { staticClass: "login-modal-form-input" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.confirmpassword,
                                        expression: "confirmpassword"
                                      }
                                    ],
                                    staticClass: "form-control marginB-24",
                                    class: {
                                      "input-box": true,
                                      "is-danger": _vm.inputValidationErrors.has(
                                        "confirmpassword"
                                      )
                                    },
                                    attrs: {
                                      type: "password",
                                      required: "",
                                      id: "confirmpassword",
                                      name: "confirmpassword",
                                      placeholder: "Confirm Password",
                                      "data-vv-delay": "500",
                                      "data-vv-as": "password"
                                    },
                                    domProps: { value: _vm.confirmpassword },
                                    on: {
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.resetPassword.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.confirmpassword =
                                          $event.target.value
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.confirmPasswordError,
                                      expression: "confirmPasswordError"
                                    }
                                  ],
                                  staticClass:
                                    "login-modal-text login-modal-text--xs failedColor"
                                },
                                [
                                  _vm._v(
                                    "\n                  Passwords do not match.\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "login-modal-footer marginT0 login-modal-footer--widePadding"
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass:
                                        "button-regular button-regular--send px-4 login-modal-btn login-modal-btn--bold login-modal-btn--full-width margin0",
                                      attrs: {
                                        variant: "primary",
                                        type: "submit"
                                      },
                                      on: { click: _vm.resetPassword }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Send\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0acaf435", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0acaf435","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/ResetPassword.vue
// module id = 1806
// module chunks = 0